import { useEffect, useMemo, useRef, useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  ZoomControl,
  FeatureGroup,
  GeoJSON,
} from "react-leaflet";
import { EditControl } from "react-leaflet-draw";

import clientComponent from "../config/clientComponents";
import ChangeView from "../utils/ChangeView";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";
import "leaflet-fullscreen/dist/Leaflet.fullscreen.js";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
// import "react-leaflet-markercluster/dist/styles.min.css"; // sass
// import CustomMarker from "./client/cdg/CustomMarker";
// import MarkerClusterGroup from "react-leaflet-markercluster";
import MarkerClusterGroup from "react-leaflet-cluster";

// require("react-leaflet-markercluster/dist/styles.min.css"); // inside .js file

const Map = ({
  data,
  selectedInstitution,
  setSelectedInstitution,
  client,
  filtersKeys,
  filters,
  scrollbarRef,
  lineRefs,
  customMarkerRefs,
  popupRefs,
  mapRef,
  setMapRef,
  sizeState,
  userCurrentPosition,
  selectedGeoAdress,
  setFilteredEntities,
}) => {
  const clusterRef = useRef(null);

  //--- Dynamic import
  const MarkerIcon = clientComponent["MarkerIcon"];
  const MapLegend = clientComponent["MapLegend"];
  const CustomMarker = clientComponent["CustomMarker"];

  let MarkerPopup = {};
  if (process.env.REACT_APP_POPUP === "true") {
    MarkerPopup = clientComponent["MarkerPopup"];
  }

  let GeoData = {};
  if (process.env.REACT_APP_GEODATA === "true") {
    GeoData = clientComponent["GeoData"];
  }

  //--- Get overlayScrollbar Instance from the parent component
  let scrollbarInstance = {};
  if (scrollbarRef.current) {
    scrollbarInstance = scrollbarRef.current.osInstance();
  }

  //--- Creation of the marker component list
  const markers = data.map((entity, i) => {
    let isSelected = false;
    let colorsArray = [];
    let innerIcon = "";
    if (entity.latitude != null && entity.longitude != null) {
      //--- Create Array of colors looping on first filter key
      if (filtersKeys.length > 0) {
        for (const element of entity[filtersKeys[0]]) {
          for (const filter of filters[filtersKeys[0]].values) {
            if (element === filter.slug) {
              colorsArray.push(filter.color);
              innerIcon = filter.icon;
            }
          }
        }
      }

      //--- Allow to put active state on selected Institution marker
      if (selectedInstitution && entity.id === selectedInstitution.id) {
        isSelected = true;
      }
      return (
        <CustomMarker
          entity={entity}
          MarkerIcon={MarkerIcon(
            entity[filtersKeys[0]],
            colorsArray,
            isSelected,
            null,
            false,
            selectedInstitution,
            innerIcon,
            entity
          )}
          setSelectedInstitution={setSelectedInstitution}
          scrollbarInstance={scrollbarInstance}
          lineRefs={lineRefs}
          i={i}
          colorsArray={colorsArray}
          key={"customMarker" + entity.id}
          innerIcon={innerIcon}
          ref={customMarkerRefs.current[i]}
          popupRefs={popupRefs}
          filtersKeys={filtersKeys}
          sizeState={sizeState}
        />
      );
    } else {
      return false;
    }
  });
  //--- Creation and memoîzation component Cluster
  const markerGroup = useMemo(() => {
    return (
      <MarkerClusterGroup
        iconCreateFunction={(cluster) =>
          MarkerIcon(null, null, false, cluster, true, selectedInstitution)
        }
        //--- Change this number to change cluster radius, when 0 -> disable clustering
        maxClusterRadius={
          process.env.REACT_APP_CLUSTER
            ? Number(process.env.REACT_APP_CLUSTER)
            : 0
        }
        showCoverageOnHover={false}
        spiderfyOnMaxZoom={true}
        ref={clusterRef}
      >
        {markers}
      </MarkerClusterGroup>
    );
  }, [markers]);

  const tileLayerUrl =
    process.env.REACT_APP_TILELAYER?.length > 0
      ? process.env.REACT_APP_TILELAYER
      : "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

  return (
    <>
      <MapContainer
        className="col-auto map__leaflet"
        zoomControl={false}
        scrollWheelZoom={false}
        // whenCreated={(map) => {
        //   mapRef.current = map;
        // }}
      >
        <ChangeView
          markers={markers}
          selectedInstitution={selectedInstitution}
          data={data}
          customMarkerRefs={customMarkerRefs}
          mapRef={mapRef}
          setMapRef={setMapRef}
          clusterRef={clusterRef}
          MarkerIcon={MarkerIcon}
          popupRefs={popupRefs}
          sizeState={sizeState}
          userCurrentPosition={userCurrentPosition}
          selectedGeoAdress={selectedGeoAdress}
          setFilteredEntities={setFilteredEntities}
        />
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          // url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
          url={tileLayerUrl}
          className="mapTiles"
        />
        <ZoomControl
          position={`${
            process.env.REACT_APP_SIDEBAR === "left" ? "topright" : "topleft"
          }`}
        />
        {markerGroup}
        {process.env.REACT_APP_GEODATA === "true" && !!GeoData && <GeoData />}

        {MapLegend && <MapLegend filters={filters} filtersKeys={filtersKeys} />}
      </MapContainer>
    </>
  );
};

export default Map;
